// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__lebPK","animated-logo":"loader_animated-logo__dhtCE","pulse":"loader_pulse__Y7nhA","status":"loader_status___tlBB"};